var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodSq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment_options_logos"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 273",
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 3.5,
    stroke: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 917"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5236 35.8736C20.412 35.8736 21.2703 34.5862 21.442 32.931H24.7038C24.7038 36.2414 22.472 39 18.5236 39C14.0601 39 12 36.0575 12 32.0115V29.9885C12 25.9425 14.0601 23 18.5236 23C22.3004 23 24.5321 25.7586 24.7038 29.069H21.442C21.442 27.5977 20.412 26.1264 18.5236 26.1264C16.4635 26.1264 15.4335 27.5977 15.4335 29.8046V32.1954C15.6051 34.4023 16.4635 35.8736 18.5236 35.8736Z",
    fill: "#EE741F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.915 39C27.6231 39 25.2197 36.0575 25.2197 32.0115V29.9885C25.3914 25.9425 27.6231 23 31.915 23C36.2068 23 38.4385 25.9425 38.4385 29.9885V32.0115C38.6102 36.0575 36.3784 39 31.915 39ZM31.915 26.1264C29.8549 26.1264 28.8249 27.5977 28.8249 29.8046V32.1954C28.8249 34.4023 29.8549 35.8736 31.915 35.8736C33.975 35.8736 35.0051 34.4023 35.0051 32.1954V29.8046C35.0051 27.5977 33.975 26.1264 31.915 26.1264Z",
    fill: "#EE741F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.9915 23.3723C49.94 23.3723 52.0001 25.947 52.0001 29.4413V32.5677C52.0001 36.062 49.94 38.6367 45.9915 38.6367H39.6396V23.3723H45.9915ZM48.5666 29.4413C48.5666 27.4183 47.5366 26.4987 45.4765 26.4987H43.4164V35.6941H45.4765C47.5366 35.6941 48.5666 34.5907 48.5666 32.7516V29.4413Z",
    fill: "#EE741F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodSq);
export default __webpack_public_path__ + "static/media/cod-sq.4c51f35caad4b033c229f7ad11f0a06f.svg";
export { ForwardRef as ReactComponent };